import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { LogsComponent } from './pages/logs/logs.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [MsalGuard] },
  { path: 'about', component: AboutComponent, canActivate: [MsalGuard] },
  { path: 'logs', component: LogsComponent, canActivate: [MsalGuard] },
  { path: '**', redirectTo: '' }
];
